export { default as ThingDetailsContainer } from "./thing_details_container";
